import WorkHistorySummary from "./WorkHistorySummary";

export default WorkHistorySummary;
